export const FUNNEL_STORAGE_KEY = 'hwage-spa';
export const SUCCESS_QUESTIONS_STORAGE_KEY = 'success_questions';
export const DELAY_TRANSITION_MS_DEFAULT = 500;
export const DELAY_TRANSITION_MS_QUESTIONS = 300;
export const PRP_FLOW_V1 = '1';
export const PRP_FLOW_V2 = '2';
export const UNINITIALIZED = 0;
export const LOADING = 1;
export const LOADED = 2;
export const INTERACTIVE = 3;
export const COMPLETED = 4;
export const TIME_IN_MS_BEFORE_REDIRECT = 800;
/**
 * URLs
 */
// eslint-disable-next-line no-undef
export const ABSOLUT_URI = getAbsoluteUri();
export const STATIC_URL = getStaticUrl();
export const API_URL = window.location.origin;
export const PRIZE_CHOICES_URL = `${API_URL}/healthywager/prize-choices/`;
export const PRIZE_URL = `${API_URL}/healthywager/prize/`;
export const PRIZE_URL_HFT27 = `${API_URL}/healthywager/prize/1/`;
export const APP_DOWNLOAD_URL_APPLE = 'https://itunes.apple.com/us/app/healthywage-lose-weight-win/id1001285466?mt=8';
export const APP_DOWNLOAD_URL_GOOGLE = 'https://play.google.com/store/apps/details?id=com.healthywage';
// eslint-disable-next-line no-undef
export const UPSELL_REFERRAL_PATH = getUpsellReferralPath();
export const LOGIN_REQUIRE_CAPTCHA = getLoginRequireCaptcha();
export const MIN_BET_VALUE = getMinBetValue();
const DEFAULT_MIN_BET_VALUE = 200;
export const SITE_CURRENCY_SIGN = getSiteCurrencySign();
export const PAYMENTS_HEALTHYWAGER_PATH = getPaymentsHwagerPath();
/**
 * FUNCTIONS
 */
export function isMobile() {
  return screen.width < 650;
}

function getAbsoluteUri() {
  try {
    // eslint-disable-next-line no-undef
    return absoluteUri; // saved on landing_pages/base_vue_template.html
  } catch (error) {
    return '/';
  }
}

function getStaticUrl() {
  try {
    // eslint-disable-next-line no-undef
    return staticUrl; // saved on landing_pages/base_vue_template.html
  } catch (error) {
    return '/static/';
  }
}

function getUpsellReferralPath() {
  try {
    // eslint-disable-next-line no-undef
    return upsellReferralPath; // saved on landing_pages/base_vue_template.html
  } catch (error) {
    return '/referrals/57/';
  }
}

function getLoginRequireCaptcha() {
  try {
    // eslint-disable-next-line no-undef
    return loginRequireCaptcha; // saved on landing_pages/base_vue_template.html
  } catch (error) {
    return false;
  }
}

function getMinBetValue() {
  try {
    // eslint-disable-next-line no-undef
    return siteMinBetValue; // saved on landing_pages/base_vue_template.html
  } catch (error) {
    return DEFAULT_MIN_BET_VALUE;
  }
}

function getSiteCurrencySign() {
  try {
    // eslint-disable-next-line no-undef
    return siteCurrencySign; // saved on landing_pages/base_vue_template.html
  } catch (error) {
    return '$';
  }
}

function getPaymentsHwagerPath() {
  try {
    // eslint-disable-next-line no-undef
    return paymentsHwagerPath; // saved on landing_pages/base_vue_template.html
  } catch (error) {
    return '/payments/57/';
  }
}

export function getUserTimezoneOffsetVar() {
  try {
    // eslint-disable-next-line no-undef
    return userTimezoneOffset; // saved on landing_pages/base_vue_template.html
  } catch (error) {
    return '+0000';
  }
}

export function getUserTimezoneVar() {
  try {
    // eslint-disable-next-line no-undef
    return userTimezone; // saved on landing_pages/base_vue_template.html
  } catch (error) {
    return 'US/Pacific';
  }
}

// User agents FB Signup failing
const excludeUserAgents = [
  'Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 15_6 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 16_0_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/16.0 Mobile/15E148 Safari/604.1',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 16_1_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/16.1 Mobile/15E148 Safari/604.1',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 16_4_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/16.4 Mobile/15E148 Safari/604.1',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 16_5_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/16.5.1 Mobile/15E148 Safari/604.1',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 16_6 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/118.0.5993.92 Mobile/15E148 Safari/604.1',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 16_6 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/120.0.6099.119 Mobile/15E148 Safari/604.1',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 16_6 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/16.6 Mobile/15E148 Safari/604.1',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 16_6_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/16.6 Mobile/15E148 Safari/604.1',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 16_7 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko)',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 16_7_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/16.6 Mobile/15E148 Safari/604.1',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 17_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/118.0.5993.92 Mobile/15E148 Safari/604.1',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 17_0_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 17_0_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 17_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/119.0.6045.169 Mobile/15E148 Safari/604.1',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 17_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 17_1_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 17_1_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.1.1 Mobile/15E148 Safari/604.1',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 17_1_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 17_1_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.1.2 Mobile/15E148 Safari/604.1',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 17_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 17_2_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 17_2_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.2 Mobile/15E148 Safari/604.1',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 17_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko)',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 17_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 17_3_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148',
  'Mozilla/5.0 (iPhone; CPU iPhone OS 17_3_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.3.1 Mobile/15E148 Safari/604.1',
  'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.1.2 Safari/605.1.15'
]

export function hideFBButtonByUserAgent(userAgent) {
  if (!userAgent) return false;
  let retVal =
    userAgent.includes('Snapchat') ||
    userAgent.includes('Instagram') ||
    (userAgent.includes('Android') && userAgent.includes('FB_IAB')) ||
    (userAgent.includes('iPad') && userAgent.includes('musical_ly')) ||
    ((userAgent.includes('iPhone') || userAgent.includes('iPad')) &&
      (userAgent.includes('BytedanceWebview') ||
        userAgent.includes('Pinterest') ||
        userAgent.includes('FBAN') ||
        userAgent.includes('FBDV') ||
        userAgent.includes('FBMD') ||
        userAgent.includes('FBSN') ||
        userAgent.includes('FBSV') ||
        userAgent.includes('FBSS') ||
        userAgent.includes('FBID') ||
        userAgent.includes('FBLC') ||
        userAgent.includes('FBOP') ||
        userAgent.includes('musical_ly')));
  if (!retVal && excludeUserAgents.some(ua => userAgent.includes(ua))) {
    retVal = true;
  }
  return retVal;
}
